import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';

/**
 * Protects admin-only routes.
 * Checks localStorage for adminToken and verifies it with the backend.
 * Redirects to /admin/login if token is missing or invalid.
 */
const AdminProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState('checking'); // 'checking' | 'authorized' | 'unauthorized'

  useEffect(() => {
    const token = localStorage.getItem('adminToken');

    if (!token) {
      setStatus('unauthorized');
      return;
    }

    // Verify the token is still valid with the backend
    api
      .get('/admin/auth/verify', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data?.valid) {
          setStatus('authorized');
        } else {
          localStorage.removeItem('adminToken');
          localStorage.removeItem('adminUser');
          setStatus('unauthorized');
        }
      })
      .catch(() => {
        // Token invalid or expired
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        setStatus('unauthorized');
      });
  }, []);

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-blue-400 mb-4" />
          <p className="text-gray-400 text-sm">Verifying session…</p>
        </div>
      </div>
    );
  }

  if (status === 'unauthorized') {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminProtectedRoute;

